import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import styles from './styles.module.sass';

class Expansion extends PureComponent {
  static propTypes = {
    label: PropTypes.string,
    children: PropTypes.any,
    defaultExpanded: PropTypes.bool
  };

  render() {
    const {label, children, defaultExpanded} = this.props;

    if (!children) return null;

    return (
        <ExpansionPanel className={cx(styles.panel)} defaultExpanded={defaultExpanded}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
            <Typography className={styles.panelTitle}>{label}</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={styles.panelDetails}>
            {children}
          </ExpansionPanelDetails>
        </ExpansionPanel>
    );
  }
}

export default Expansion;


// WEBPACK FOOTER //
// ./src/components/common/Expansion/Expansion.jsx